import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

export async function setLocalStorageItem(key: string, value: string) {
  return Capacitor.isPluginAvailable("Preferences")
    ? Preferences.set({ key, value })
    : localStorage.setItem(key, value);
}

export async function getLocalStorageItem(key: string): Promise<string | null> {
  try {
    return Capacitor.isPluginAvailable("Preferences")
      ? (await Preferences.get({ key })).value
      : localStorage.get(key);
  } catch (e) {
    console.log(`[storage]: ${e}`);
    return null;
  }
}

export async function removeLocalStorageItem(key: string) {
  return Capacitor.isPluginAvailable("Preferences")
    ? Preferences.remove({ key })
    : localStorage.removeItem(key);
}
